// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    Handler,
    markSkipOnCompleteIfOnErrorIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import {
    realTimeInvoice,
    RealTimeInvoiceModel,
    realTimeInvoicePdf,
} from "@stoneage/App/Services/RealTimeInvoice/RealTimeInvoiceService";

interface Props {
    apiParameter: any;
    apiResult: ServiceResult<RealTimeInvoiceModel>;
}

type Parameter = {
    onSuccess?: (result: any) => void;
    onError?: (e: any) => void;
    invoiceNumber: string;
    isInternational: boolean;
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameters: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await realTimeInvoice(props.parameter);
};

export const onSuccess: HandlerType = props => {
    if (props.apiResult && props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult);
        window.open(`${realTimeInvoicePdf}/${props.apiParameter.invoiceNumber}`, "_blank");
    }
};

export const OnError: HandlerType = props => {
    if (props.apiResult && !props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult);
    }
};

export const chain = [PopulateApiParameters, RequestDataFromApi, onSuccess, OnError];

const getRealTimeInvoiceData = createHandlerChainRunner(chain, "GetRealTimeInvoiceData");
export default getRealTimeInvoiceData;
